import { render, staticRenderFns } from "./magazinesListPage.vue?vue&type=template&id=dee31c40&"
import script from "./magazinesListPage.vue?vue&type=script&lang=ts&"
export * from "./magazinesListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports